import { INACTIVE_ACCOUNT_STATUSES } from '@/utils/account-status';
import { type AlertedFilter } from './use-creator-filters';

// "orphaned" = alertado (manual o IA) con collector banned/failed/deleted —
// `alert_pending_at` cubre ambos orígenes desde la migración 176. Las
// opciones ai_*/appeal_* filtran directamente por ai_analysis_status /
// appeal_status.
function orphanedClause(): string {
  const o = INACTIVE_ACCOUNT_STATUSES.map(
    (s) => `collector.account_status = "${s}"`
  ).join(' || ');
  return `alert_pending_at != "" && (${o})`;
}

function withActiveOwnerClause(): string {
  const o = INACTIVE_ACCOUNT_STATUSES.map(
    (s) => `collector.account_status != "${s}"`
  ).join(' && ');
  return `alert_pending_at != "" && collector != "" && ${o}`;
}

// ai_rejected exige `alert_pending_at != ""` para acotar al backlog real
// (≈7.6k) en lugar del histórico de rechazos IA (≈22k). El hook
// lead-attention-flag.pb.js mantiene la invariante: la marca se limpia
// cuando el collector apela, auto-borra, o el admin valida — así el
// filtro sólo lista lo que aún requiere revisión humana. Apelaciones
// pendientes y validaciones tienen su propio filtro arriba.
type DirectAlertedFilter = Exclude<AlertedFilter, 'orphaned' | 'with_active_owner'>;

const ALERT_MAP: Record<DirectAlertedFilter, string> = {
  ai_pending: 'ai_analysis_status = "pending"',
  ai_rejected:
    'ai_analysis_status = "rejected_by_ai" && alert_pending_at != ""',
  ai_validated: 'ai_analysis_status = "validated"',
  appeal_pending: 'appeal_status = "pending_review"',
  // Leads que el collector eliminó vía "Eliminar lead" (user_deleted_at).
  // Opción admin-only: el collector no los ve nunca (buildBaseFilter le
  // añade user_deleted_at = "").
  discarded: 'user_deleted_at != ""',
};

export function alertedClause(v: AlertedFilter | undefined): string {
  if (!v) return '';
  if (v === 'orphaned') return orphanedClause();
  if (v === 'with_active_owner') return withActiveOwnerClause();
  return ALERT_MAP[v];
}
